import qs from 'qs'
import { get } from '../../components/helpers/Api'
import NewBuyOffer from '../../components/newbuyoffer/NewBuyOffer'

const NewOfferPage = (props) => {
    return <NewBuyOffer {...props} />
}

NewOfferPage.getInitialProps = async (ctx) => {
    const paths = ctx.asPath.split('/')

    const values = qs.parse(paths[paths.length - 1].replace('market?', ''))

    values['search_page'] = false
    values['searchType'] = values['search_type']
        ? values['search_type']
        : 'sales'
    values['tab'] = values['tab'] ? values['tab'] : 'sales'

    if (values['collection'] && values['collection'] !== '*')
        values['collection_details'] = await get(
            'collections/' + values['collection'],
            'wax-api',
        )

    return values
}

export default NewOfferPage
